<template>
  <form-panel
    width="short"
    @closePanel="onCloseModal">
    <div class="task-content">
      <h3>{{ currentTask.title }}</h3>
      <p>Creado por:&nbsp;&nbsp;{{ profile.name }}</p>
      <h4>Fecha:</h4>
      <h5>{{ currentTask.createdAt | date('DD/MM/YYYY') }}</h5>
      <h4>Fecha programada para activación:</h4>
      <h5>{{ currentTask.dueDate | date('DD/MM/YYYY') }}</h5>
      <h4>Descripción:</h4>
      <h5>{{ currentTask.description }}</h5>
      <el-row>
        <el-col :span="12">
          <el-checkbox
            class="check"
            @change="onSelect">¿Asignar una oportunidad?</el-checkbox>
        </el-col>
      </el-row>
      <el-row>
        <el-col
          :span="12"
          class="el-select">
          <el-select
            v-model="currentTask.opportunityId"
            :disabled="onCheck"
            class="el-select"
            placeholder="Elija una modelo">
            <el-option
              v-for="(oportunity, index) in opportunities"
              :key="index"
              :label="oportunity.title"
              :value="oportunity.id"/>
          </el-select>
        </el-col>
      </el-row>
      <div class="save">
        <el-button
          :disabled="onCheck"
          type="primary"
          style="width: 100%"
          @click="updateTask(currentTask)">
          Asignar
        </el-button>
      </div>
    </div>
  </form-panel>
</template>

<script>
import FormPanel from '@/components/_shared/form-panel'
import http from '@/services/http.service'

export default {
  name: 'TasksPreview',
  components: {
    FormPanel
  },
  props: {
    currentTask: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      opportunities: [],
      opportunityItem: '',
      onCheck: true
    }
  },
  computed: {
    profile () {
      return this.$store.getters['profile/me']
    }
  },
  mounted () {
    http.get('opportunities', {})
      .then(response => {
        this.opportunities = response.data.items
      })
  },
  methods: {
    onCloseModal () {
      this.$store.dispatch('app/togglePrevTaskPanel')
    },
    onSelect () {
      this.onCheck = !this.onCheck
    },
    updateTask (model) {
      this.$store.dispatch('tasks/save', model)
        .then(response => {
          this.$message.success('La tarea se ha actualizado con éxito')
        })
        .catch(e => {
          this.$message.error('La tarea no pudo se actualizada')
          model.completed = !model.completed
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .task-content{
    height: 100vh;
    padding: 20px 20px 0 20px;
    position: relative;
    .el-select{
      margin-top: 10px;
    }
    h3{
      margin: 0;
      @include font-lato(21px, regular);
      color: #707070;
    }
    p {
      @include font-lato(14px, regular);
      color:#3E3E3E;
    }
    h4{
      @include font-lato(12px, bold);
      color: #3E3E3E;
    }
    .check{
      @include font-lato(12px, bold);
      color: #3E3E3E;
    }
    h5{
      @include font-primary(13px, regular);
      color: #707070;
    }
    .save{
      height: 60px;
      padding: 20px 0;
      position: relative;
      button{
        position: absolute;
        right: 0px;
        box-shadow: 0 3px 6px 0 rgba(231, 18, 14, 0.5);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/app/tasks/tasks-preview.vue